/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Dashboard Icon component.
 */
export const SideNavDashboardIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 23 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='8.42105' height='9.42857' rx='0.5' stroke={iconColor} strokeWidth='1.5' />
      <rect x='12.5791' y='9.57129' width='8.42105' height='9.42857' rx='0.5' stroke={iconColor} strokeWidth='1.5' />
      <rect x='12.5791' y='1' width='8.42105' height='6' rx='0.5' stroke={iconColor} strokeWidth='1.5' />
      <rect x='1' y='13' width='8.42105' height='6' rx='0.5' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default SideNavDashboardIcon;
